import useAlert from "@/components/common/modals/alert/context";
import { auth } from "@/config/firebase";
import useFormStatus from "@/context/form";
import useUser from "@/context/user";
import { i18n } from "@/utils/i18n";
import { log } from "@/utils/logger";
import { signOut } from "firebase/auth";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useMenu = () => {
    const navigate = useNavigate();
    const path = useLocation().pathname;
    const logout = useUser(state => state.logout);
    const isDirty = useFormStatus(state => state.isDirty);
    const openAlert = useAlert(state => state.open);

    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
    const open = Boolean(anchorEl);

    const onOpenMenu = (event: React.MouseEvent<SVGSVGElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const onProfile = () => {
        const trigger = () => {
            setAnchorEl(null);

            if (path === "/profile") return;
            navigate("/profile");
        };

        if (isDirty) {
            return openAlert({
                title: i18n.t("alert.form.title"),
                message: i18n.t("alert.form.message"),
                actions: { confirm: { callback: trigger } },
            });
        }

        trigger();
    };

    const onLogout = async () => {
        try {
            setAnchorEl(null);
            await signOut(auth);
            logout();
            navigate("/sign-in");
        } catch (e) {
            log.error(e);
        }
    };

    return {
        onProfile,
        onLogout,
        onOpenMenu,
        open,
        anchorEl,
        setAnchorEl,
    };
};

export { useMenu };
